/**
 * Upload error primitives, split out of file-upload.ts so the intake helpers (file-intake.ts) can
 * throw/recognize them without importing file-upload.ts back (which imports the intake helpers).
 * file-upload.ts re-exports UserFacingUploadError / isUserFacingUploadError, so existing importers
 * keep working unchanged.
 */

export class UserFacingUploadError extends Error {
  code: string;
  userMessage: string;

  constructor(code: string, userMessage: string, message?: string) {
    super(message ?? userMessage);
    this.name = 'UserFacingUploadError';
    this.code = code;
    this.userMessage = userMessage;
  }
}

export function isUserFacingUploadError(error: unknown): error is UserFacingUploadError {
  return error instanceof UserFacingUploadError;
}

export function isEncryptedPdfError(error: unknown): boolean {
  const message = String((error as any)?.message ?? error ?? '').toLowerCase();
  return (
    message.includes('input document to `pdfdocument.load` is encrypted') ||
    message.includes('input document to pdfdocument.load is encrypted') ||
    message.includes('encrypted')
  );
}
